module.exports = __webpack_public_path__ + "static/media/clinical_email_icon.413f4fa1.svg";